<template>
  <section>
    <div v-if="inspection && inspection !== 'noData'" class="custom-vehicle-details-host">
      <div class="row custom-vehicle-details">
        <div class="col custom-vehicle">
          <div class="custom-vehicle-icon">
            <i class="fa-solid fa-car"></i>
          </div>
          <div class="custom-vehicle-vin">
            <div class="row">
              <div class="col">
                <span class="custom-value">{{ inspection?.vehicle?.vin }}</span>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <span class="custom-value-normal">{{ inspection?.vehicle?.year }} {{ inspection?.vehicle?.make }} {{
                  inspection?.vehicle?.model }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-4">
          <div class="row">
            <div class="col">
              <span class="custom-label">Inspection #:</span>
              <span class="custom-value">{{ inspection?.adasInspection }}</span>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <span class="custom-label">Insurance:</span>
              <span class="custom-value-normal">{{ inspection?.insurance }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row custom-ro">
        <div class="col pt-2">
          <span class="custom-label">RO #:</span>
          <span class="custom-value">{{ inspection?.ronumber }}</span>
        </div>
        <!-- <div v-if="isInsurer" class="col-3 pt-2">
          <span class="custom-label"># Repair Lines:</span>
          <span class="custom-value">{{ inspection?.repairLineCount }}</span>
        </div> -->
        <!-- <div v-else class="col-3 pt-2">
          <span class="custom-label"># Calibrations:</span>
          <span class="custom-value">{{ inspection?.repairLineCount }}</span>
        </div> -->
        <!-- Every action on this inspection in one right-aligned row. They were spread across three
             grid columns over two rows, which read as clutter rather than as a set of choices. -->
        <div class="col-auto ms-auto custom-actions">
          <a v-if="isShowInvoice" href="#" :disabled="loading.invoice" class="btn btn-link" @click="invoice">
            <i :class="loading.invoice ? 'fa-solid fa-spinner fa-spin' : 'fa-solid fa-file-invoice-dollar'" class="me-1"></i>View Invoice
          </a>
          <a href="#" :disabled="loading.report" class="btn btn-link" @click="report">
            <i :class="loading.report ? 'fa-solid fa-spinner fa-spin' : 'fa-solid fa-file-lines'" class="me-1"></i>View Report
          </a>
          <RepairLines :adas="inspection?.adas" buttonName="Repair Lines" Title="click here to view lines" />
          <!-- Issue 622: created-from-PDF inspections can view the original uploaded estimate. -->
          <a v-if="inspection && inspection.repairDocument" href="#" class="btn btn-link"
            title="View the uploaded PDF estimate this inspection was created from" @click.prevent="downloadPdf">
            <i class="fa-solid fa-file-pdf me-1"></i>View Uploaded PDF
          </a>
          <!-- Sits here rather than beside the shop below, so the actions stay in one place. -->
          <a v-if="customerShop" href="#" class="btn btn-link" :title="customerShop.email
              ? 'Email this shop the ADAS Map report'
              : 'This shop has no email address yet'"
            @click.prevent="emailCustomer">
            <i class="fa-solid fa-envelope me-1"></i>Email Customer Report
          </a>
        </div>
      </div>

      <!-- The customer shop this estimate was uploaded for. Absent on inspections that did not come in
           through a provider upload, which is why the whole row is conditional. -->
      <div v-if="customerShop" class="row custom-shop">
        <div class="col pt-2 custom-shop-line">
          <span class="custom-label">Customer Shop:</span>
          <span class="custom-value">{{ customerShop.shopName }}</span>
          <span v-if="customerShop.contactName" class="custom-value-normal">({{ customerShop.contactName }})</span>
          <!-- The address is the same action as Email Customer Report above: clicking the shop's email
               is what anyone would try first, and a mailto would send an empty message without the
               report attached. -->
          <a v-if="customerShop.email" href="#" class="custom-value-normal custom-shop-email"
            title="Email this shop the ADAS Map report" @click.prevent="emailCustomer">
            <i class="fas fa-envelope me-1"></i>{{ customerShop.email }}
          </a>
          <span v-if="customerShop.phone" class="custom-value-normal">
            <i class="fas fa-phone me-1"></i>{{ customerShop.phone }}
          </span>
        </div>
      </div>
    </div>
    <DialogEmailCustomer
      :show="showEmailCustomer"
      :source="source"
      :adasInspection="inspection?.adasInspection"
      @close="showEmailCustomer = false"
    />
    <div v-if="!inspection">
      <Loader vehicleSummary="true" />
    </div>
    <div v-if="inspection === 'noData'">
      <Loader vehicleSummaryEmpty="true" />
    </div>
  </section>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import axios from 'axios'
import { authStore } from '@/stores/auth'
import { adasStore } from '@/stores/adas'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import RepairLines from '@/components/dashboard/details/RepairLines.vue'
import DialogEmailCustomer from '@/components/dashboard/forms/DialogEmailCustomer.vue'
import Loader from '@/components/utilities/elements/Loader.vue'
import { customerStore } from '@/stores/customer'
import moment from 'moment'
export default {
  name: 'VehicleSummary',
  components: {
    FontAwesomeIcon,
    RepairLines,
    DialogEmailCustomer,
    Loader
  },
  data() {
    return {
      customerShop: null,
      showEmailCustomer: false
    }
  },
  props: {
    vin: {
      type: String,
      default: ''
    },
    status: {
      type: String,
      default: ''
    },
    // Issue 622: the inspection's ADAS source, so a PDF download routes to the right environment.
    source: {
      type: [String, Number],
      default: ''
    }
  },
  computed: {
    ...mapState(authStore, ['profile']),
    ...mapState(adasStore, ['inspectionInfo', 'loading']),
    isInsurer() {
      let _is = false
      if (this.profile.connectClass === 1) {
        _is = true
      }
      return _is
    },
    inspection() {
      return this.inspectionInfo
    },
    isShowInvoice() {
      let _is = false
      // const ids = [2, 8, 11, 3, 4, 9, 12, 13, 7]
      const ids = [4, 9, 7]
      if (ids.includes(this.status)) {
        _is = true
      }
      return _is
    }
  },
  emits: ['report', 'invoice'],
  watch: {
    // The summary is reused as the user moves between inspections, so reload the shop whenever the
    // inspection behind it changes rather than only on mount.
    'inspection.adasInspection': {
      immediate: true,
      handler() { this.loadCustomerShop() }
    }
  },
  methods: {
    ...mapActions(customerStore, ['getInspectionShop']),
    async loadCustomerShop() {
      this.customerShop = null
      const id = this.inspection && this.inspection.adasInspection
      if (!id || !this.source) return
      try {
        this.customerShop = await this.getInspectionShop(this.source, id)
      } catch (e) {
        // Nothing to show is the normal case for inspections that did not come from an upload.
        this.customerShop = null
      }
    },
    emailCustomer() {
      this.showEmailCustomer = true
    },
    formatDate(data) {
      let result = null
      if (data) {
        result = moment(data).format('MM/DD/YYYY')
      }
      return result
    },
    report() {
      this.$emit('report')
    },
    invoice() {
      this.$emit('invoice')
    },
    // Issue 622: download the uploaded PDF estimate for this inspection (routed to its own ADAS source).
    async downloadPdf() {
      if (!this.inspection || !this.inspection.repairDocument) return
      try {
        const apiUrl = window.config ? window.config.apiUrl : ''
        const resp = await axios.get(
          `${apiUrl}/estimate/document/${this.inspection.repairDocument}/download?source=${encodeURIComponent(this.source)}`,
          { headers: { Authorization: `Bearer ${authStore().token}` }, responseType: 'blob' }
        )
        const url = window.URL.createObjectURL(new Blob([resp.data], { type: 'application/pdf' }))
        const a = document.createElement('a')
        a.href = url
        a.download = `estimate-${this.inspection.repairDocument}.pdf`
        document.body.appendChild(a)
        a.click()
        a.remove()
        window.URL.revokeObjectURL(url)
      } catch (e) {
        console.error('downloadPdf failed', e)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-vehicle-details-host {
  background-color: rgb(244, 249, 247);
  border-radius: 5px;
  padding: 5px;
  padding-bottom: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.custom-ro {
  border-top: 1px solid #d3d3d3;
  margin: 5px;
}

.custom-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  column-gap: 1.25rem;
}
.custom-actions .btn-link {
  padding: 0;
  text-decoration: none;
  white-space: nowrap;
}
.custom-actions .btn-link:hover {
  text-decoration: underline;
}
.custom-shop-line {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  column-gap: 1rem;
}
.custom-shop-email {
  text-decoration: none;
}
.custom-shop-email:hover {
  text-decoration: underline;
}
.custom-shop {
  border-top: 1px solid #d3d3d3;
  margin: 5px;
}

.custom-vehicle {
  display: inline-flex;
  position: relative;
  margin: 5px;
}

.custom-vehicle-icon {
  margin-top: 5px;
  font-size: 1.5em;
  margin-right: 10px;
}

.custom-vehicle-vin {
  margin-left: 10px;

  span {
    text-align: center;
  }
}

.custom-label {
  font-size: 1em;
  font-weight: 500;
  margin-right: 10px;
}

.custom-value {
  font-size: 1.1em;
  font-weight: 500;
}

.custom-value-normal {
  font-size: 1em;
  font-weight: normal;
}
</style>
